
const getTheme = state => state.theme
const getDevice = state => state.device
const getPkg = state => state.pkg

export default {
  getTheme,
  getDevice,
  getPkg
}



// WEBPACK FOOTER //
// ./src/store/modules/app/getters.js